<template>
  <main class="page-horseman-storeMapping page-main__wrapper layout">
    <!-- 条件查询部分 -->
    <section class="filter-box">
      <div class="top-btns">
        <el-button @click="$_modify(-1)" class="btn__add">新增门店映射</el-button>
        <el-button @click="$_batchStores" class="btn__add">批量导入门店映射</el-button>
        <el-button class="btn__add" @click="$_bind()">人工关联门店</el-button>
      </div>
      <el-form :inline="true" class="filter-form">
        <el-form-item label="运营商名称:">
          <div class="autocomplete-box">
            <el-autocomplete
              v-model="filter.platformName"
              :fetch-suggestions="$_handleSearchPlatform"
              :trigger-on-focus="false"
              value-key="platformName"
              @select="$_handleSelectPlatform"
            ></el-autocomplete>
            <div
              v-show="!searchPlatformData.length && filter.platformName"
              @click="$_clearSearchPlatformData"
              class="autocomplete-empty el-select-dropdown"
            >查无该运营商，请重新输入</div>
          </div>
        </el-form-item>

        <el-form-item label="品牌名称:">
          <div class="autocomplete-box">
            <el-autocomplete
              v-model="filter.brandName"
              :fetch-suggestions="$_handleSearchBrand"
              :trigger-on-focus="false"
              value-key="brandName"
              @select="$_handleSelectBrand"
            ></el-autocomplete>
            <div
              v-show="!searchBrandData.length && filter.brandName"
              @click="$_clearSearchBrandData"
              class="autocomplete-empty el-select-dropdown"
            >查无该品牌，请重新输入</div>
          </div>
        </el-form-item>

        <el-form-item label="骑手平台名称:">
          <el-select v-model="filter.sysType" filterable style="width: 110px;" placeholder="请选择">
            <el-option label="全部" :value="''"></el-option>
            <el-option
              v-for="item in filter.deliverySyses"
              :key="item.cid"
              :label="item.deliverySysName"
              :value="item.deliverySysType"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="门店名称:">
          <div class="autocomplete-box" style="width: 110px;">
            <el-autocomplete
              v-model="filter.storeName"
              :fetch-suggestions="$_handleSearchStores"
              :trigger-on-focus="false"
              value-key="storeName"
              @select="$_handleSelectStore"
            ></el-autocomplete>
            <div
              v-show="!searchStoresData.length && filter.storeName"
              @click="$_clearsearchStoresData"
              class="autocomplete-empty el-select-dropdown"
            >查无该门店，请重新输入</div>
          </div>
        </el-form-item>

        <el-form-item label="门店ID:">
          <el-input v-model="filter.storeId" style="width: 110px;"></el-input>
        </el-form-item>

        <el-form-item label="映射ID:">
          <el-input v-model="filter.mappingId" style="width: 110px;"></el-input>
        </el-form-item>

        <el-form-item label="关联情况:">
          <el-select v-model="filter.status" filterable style="width: 110px;" placeholder="请选择">
            <el-option
              v-for="item in RELATION_OPTIONS"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item>
          <el-button @click="$_search" class="search__btn">查询</el-button>
          <el-button @click="$_reset" class="reset__btn">重置</el-button>
          <el-button @click="$_export" class="export_btn">导出</el-button>
        </el-form-item>
      </el-form>
    </section>

    <main class="table-box">
      <!-- 数据列表 -->
      <el-table
        class="table-list__box"
        ref="tableList"
        :data="dataList"
        :height="tableHeight"
        :rowClassName="$_getRowClass"
        v-loading="isLoading"
        border
        stripe
        tooltip-effect="dark"
        @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column label="操作" width="300" :resizable="false">
          <template slot-scope="scope">
            <el-button class="edit__btn" @click="$_modify(scope.$index, scope.row)">编辑</el-button>
            <el-button
              :class="{'status__btn': scope.row.status === 1}"
              @click="$_update(scope.row)"
            >{{scope.row.status === 1 ? '解除关联' : '关联门店'}}</el-button>
            <el-button class="delete__btn" @click="$_update(scope.row, 3)">删除</el-button>
          </template>
        </el-table-column>
        <el-table-column
          v-for="column in columns"
          :key="column.key"
          :prop="column.key"
          :label="column.label"
          :width="column.width"
          sortable
          show-overflow-tooltip
          filter-placement="bottom"
          v-if="!column.component"
        ></el-table-column>
        <el-table-column :prop="column.key" :label="column.label" :width="column.width" v-else>
          <template slot-scope="scope">
            <component :is="column.component" :row="scope.row"></component>
          </template>
        </el-table-column>

        <div v-show="!isLoading" class="table-list__empty" slot="empty"></div>
      </el-table>
    </main>
    <!-- 分页 -->
    <div class="pagination__wrapper">
      <cd-pagination
        ref="pager"
        :total="pagination.total"
        :currPage="pagination.pageNow"
        :pageSize="pagination.pageSize"
        @changepage="$_changeCurrent"
        @changesize="$_changeSize"
        :explainShow="true"
        @refresh="$_getStoreMappingList"
      ></cd-pagination>
    </div>

    <modal-modify
      v-if="modal.show && modal.template === 'modify'"
      :title="modal.title"
      :formType="modal.type"
      :modalData="modal.data"
      @callback="$_callback"
      @close="$_close"
    ></modal-modify>

    <batch-stores
      v-if="modal.show && modal.template === 'batch'"
      :title="modal.title"
      @callback="$_callback"
      @close="$_close"
    ></batch-stores>

    <export-mapping
      v-if="modal.show && modal.template === 'export-mapping'"
      :title="modal.title"
      :filter="lastFilter"
      @callback="$_callback"
      @close="$_close"
    ></export-mapping>
  </main>
</template>

<script>
import * as Utils from "@/plugins/utils";
import resize from "@/mixins/resize";
import ModalModify from "./modal-modify";
import BatchStores from "./modal-batch-stores";
import ExportMapping from "./modal-export-mapping";
import { RELATION_OPTIONS } from "@/const/index"

const columns = [
  { key: "platformName", label: "运营商", width: 120 },
  { key: "brandName", label: "品牌", width: 120 },
  { key: "accessName", label: "供应商订阅名称", width: 160 },
  { key: "storeName", label: "门店", width: 160 },
  { key: "storeId", label: "门店ID", width: 120 },
  { key: "mappingId", label: "映射ID", width: 120 },
  { key: "status", label: "关联情况", width: 120, component: "statusTmpl" },
  { key: "identifying", label: "骑手账号标识", width: 120 },
  { key: "sysName", label: "骑手平台", width: 120 },
  { key: "note", label: "备注", width: 160 },
  { key: "creator", label: "创建人", width: 120 },
  { key: "createTime", label: "创建时间", width: 160 },
  { key: "operator", label: "最后编辑人", width: 120 },
  { key: "updateTime", label: "最后编辑时间", width: 160 }
];

export default {
  name: "horseman-platforms-stores-mapping",
  mixins: [resize],
  data() {
    return {
      RELATION_OPTIONS,
      isLoading: false,
      lastFilter:{},
      filter: {
        status: null, // 关联情况
        platformKey: "", // 运营商key
        platformName: "", // 运营商名称
        brandName: "", // 品牌名称
        brandId: "",
        deliverySyses: [],
        sysType: "",
        storeName: "", // 门店名称
        currentStoreId: "",
        storeId: "", // 门店ID
        mappingId: "" // 映射ID
      },
      searchPlatformData: [],
      searchBrandData: [],
      searchSysData: [],
      searchStoresData: [],
      tableHeight: null,
      dataList: [],
      doorData: [], // 选择的数据
      columns,
      pagination: {
        pageNow: 1,
        pageSize: 20,
        pages: 0,
        total: 0
      },
      modal: {
        show: false,
        title: "",
        template: "",
        type: "",
        data: {}
      }
    };
  },
  watch: {
    platformName(val) {
      !val && (this.filter.platformKey = "");
    },
    brandName(val) {
      !val && (this.filter.brandId = "");
    },
    storeName(val) {
      !val && (this.filter.currentStoreId = "");
    }
  },

  computed: {
    platformName() {
      return this.filter.platformName;
    },
    brandName() {
      return this.filter.brandName;
    },
    storeName() {
      return this.filter.storeName;
    }
  },

  methods: {
    //当前选中行数据
    handleSelectionChange(val) {
      this.doorData = val;
    },
    //人工
    $_bind() {
      const SELF = this;
      let content = `是否对当前选择的门店配置映射关系？
			`;
      // 分两种情况 1 没有选择数据 2 已选择数据
      if (this.doorData.length == 0) {
        $MessageBox.alert({
          content: "请选择至少1条管理数据",
        });
      } else {
				const mids = this.doorData.map(item => item.mid)
        $MessageBox.confirm({
          content,
          onOk() {
            SELF.$service
              .post("BindstoreMapping", {
                mids
              })
              .then(result => {
                if (result.$.checkResult(result, true)) {
                  $MessageBox.alert({
                    content: result.msg,
                    onOk() {
                      SELF.$_getStoreMappingList();
                    }
                  });
                }
              });
          }
        });
      }
    },
    // 批量导入门店
    $_batchStores() {
      this.modal.title = "批量导入门店映射";
      this.modal.template = "batch";
      this.modal.show = true;
    },
    // 下拉联想运营商
    $_handleSearchPlatform(platformName, cb) {
      let postData = {
        platformName: platformName,
        pageNow: 1,
        pageSize: 9999
      };
      this.$service.post("getPlatformList", postData).then(result => {
        if (result.$.checkResult(result, true)) {
          this.searchPlatformData = result.data.rows.concat([]);

          cb(result.data.rows);
        }
      });
    },
    // 选择运营商
    $_handleSelectPlatform(item) {
      this.filter.platformName = item.platformName;
      this.filter.platformKey = item.platformKey;
    },
    $_clearSearchPlatformData() {
      this.filter.platformName = "";
      this.filter.platformKey = "";
    },
    // 下拉联想品牌
    $_handleSearchBrand(brandName, cb) {
      let postData = {
        brandName: brandName,
        pageNow: 1,
        pageSize: 9999
      };
      if (this.filter.platformKey !== "") {
        Object.assign(postData, { platformKey: this.filter.platformKey });
      }
      this.$service.post("getBrands", postData).then(result => {
        if (result.$.checkResult(result, true)) {
          this.searchBrandData = result.data.rows.concat([]);
          cb(result.data.rows);
        }
      });
    },
    // 选择品牌
    $_handleSelectBrand(item) {
      this.filter.brandName = item.brandName;
      this.filter.brandId = item.brandId;
    },
    $_clearSearchBrandData() {
      this.filter.brandName = "";
      this.filter.brandId = "";
    },
    // 下拉联想门店
    $_handleSearchStores(storeName, cb) {
      let postData = {
        storeName,
        pageNow: 1,
        pageSize: 9999
      };
      this.$service.post("getStores", postData).then(result => {
        if (result.$.checkResult(result, true)) {
          this.searchStoresData = result.data.rows.concat([]);
          cb(result.data.rows);
        }
      });
    },
    // 选择门店
    $_handleSelectStore(item) {
      this.filter.storeName = item.storeName;
      this.filter.currentStoreId = item.storeId;
      this.filter.storeId = item.storeId;
    },
    $_clearsearchStoresData() {
      this.filter.storeName = "";
      this.filter.currentStoreId = "";
      this.filter.storeId = "";
    },
    // 搜索
    $_search() {
      this.pagination.pageNow = 1;
      this.$_getStoreMappingList();
    },
    // 重置
    $_reset() {
      this.filter.platformKey = "";
      this.filter.platformName = "";
      this.filter.brandName = "";
      this.filter.brandId = "";
      this.filter.sysType = "";
      this.filter.storeName = "";
      this.filter.currentStoreId = "";
      this.filter.storeId = "";
      this.filter.mappingId = "";
      this.filter.status = null;

      this.pagination.pageNow = 1;
      this.pagination.pageSize = 20;
      this.$_getStoreMappingList();
    },
    // 查询门店映射列表
    $_getStoreMappingList() {
      if (
        this.filter.storeId &&
        this.filter.currentStoreId &&
        this.filter.storeId !== this.filter.currentStoreId
      ) {
        this.dataList.splice(0);
        return false;
      }
      this.isLoading = true;
      this.$refs.tableList.clearSort();
      const postData = {
        type: 1, // 1 - 骑手, 2- 外卖平台
        platformKey: this.filter.platformKey,
        brandId: Number(this.filter.brandId),
        sysType: this.filter.sysType,
        storeId: this.filter.storeId || this.filter.currentStoreId,
        mappingId: this.filter.mappingId,
        status:this.filter.status,
        pageNow: this.pagination.pageNow,
        pageSize: this.pagination.pageSize
      };
      this.lastFilter = JSON.parse(JSON.stringify(postData));
      this.$service.post("getStoreMappings", postData).then(result => {
        if (result.$.checkResult(result, true)) {
          this.pagination.pages = result.data.pages;
          this.pagination.total = result.data.total;
          this.dataList = result.data.rows.concat([]);
        }
        this.isLoading = false;
      });
    },
    $_getRowClass({ row, rowIndex }) {
      if (row.status === 2) {
        return "is-blocked";
      }
    },
    // 切换每页size
    $_changeSize(page, size) {
      this.pagination.pageSize = size;
      this.pagination.pageNow = 1;
      this.$_getStoreMappingList();
    },
    // 切换当前页
    $_changeCurrent(val) {
      this.pagination.pageNow = val;
      this.$_getStoreMappingList();
    },
    // 更新品牌状态 - 1-启用/2-停用/3-删除

    $_update(row, status) {
      const SELF = this;
      let content = `
				<div>是否删除当前门店映射配置?</div>
				<div class="error-text">如已配置门店映射关系, 删除后同步解除关联</div>
			`;

      if (typeof status === "undefined") {
        status = row.status === 1 ? 0 : 1; // 原数据是未关联则赋值为1 已关联, 原已关联则赋值0 未关联
        content = `是否${status === 1 ? "对" : "解除"}当前门店配置${
          status === 1 ? "" : "的"
        }映射关系?`;
      }
      let mid = row.mid;
      $MessageBox.confirm({
        content,
        onOk() {
          SELF.$service
            .post("updateMappingStatus", {
              mid,
              status
            })
            .then(result => {
              if (result.$.checkResult(result, true)) {
                $MessageBox.alert({
                  content: result.msg,
                  onOk() {
                    SELF.$_getStoreMappingList();
                  }
                });
              }
            });
        }
      });
    },

    async $_modify($index, row) {
      this.modal.type = "add";
      this.modal.data = {};
      this.modal.title = "新增门店映射配置";
      if ($index !== -1) {
        this.modal.type = "edit";
        this.modal.title = "编辑门店映射配置";
        let { mid } = row;
        await this.$service
          .post("getMapping", {
            mid
          })
          .then(result => {
            if (result.$.checkResult(result, true)) {
              this.modal.data = JSON.parse(JSON.stringify(result.data));
            } else {
              return false;
            }
          });
      }
      this.modal.template = "modify";
      this.modal.show = true;
    },
    // 新增/编辑配置成功回调
    $_callback() {
      this.$_close();
      this.$_getStoreMappingList();
    },
    // 关闭弹窗
    $_close() {
      this.modal.show = false;
      this.modal.template = "";
      this.modal.type = "add";
      this.modal.data = {};
      this.modal.title = "";
    },
    //导出门店
    $_export(){
      if (!this.lastFilter.platformKey) {
        $MessageBox.alert({ content: "请选择运营商并过滤！" });
        return false;
      }
      this.modal.template = "export-mapping";
      this.modal.title = "提示";
      this.modal.show = true;
    }
  },

  components: {
    ModalModify,
    BatchStores,
    ExportMapping,
    statusTmpl: {
      template: `<span>
					{{row.status === 1 ?
						'已关联':
						row.status === 2 ?
							'关联失败' :
							row.status === 3 ? '删除' : '未关联'}}
				</span>`,
      props: { row: { type: Object, require: true } }
    }
  },

  async mounted() {
    let height = this.$refs.tableList.$el.parentElement.clientHeight;
    this.tableHeight = `${height}px`;
    // 获取骑手平台列表
    await this.$service
      .post("getAllRiderCompany", {
        pageNow: 1,
        pageSize: 9999,
        deliverySysName: ""
      })
      .then(result => {
        if (result.$.checkResult(result, true)) {
            this.filter.deliverySyses = result.data.concat([]);
        }
      });
    this.$_getStoreMappingList();
  }
};
</script>

<style lang="scss" scoped>
.layout {
  display: flex;
  flex: auto;
  flex-direction: column;
}
.page-main__wrapper {
  overflow: hidden;
  position: relative;
}

.filter-box {
  color: #68768a;
  background-color: #f5f6f7;
  padding: 20px 20px 10px 20px;

  .top-btns {
    min-height: 40px;
  }

  .filter-form {
    .autocomplete-box {
      display: inline-block;
      position: relative;
      width: 110px;
      .autocomplete-empty {
        padding: 10px;
        margin: 0;
        color: #535353;
        width: 100%;
      }
    }
    .el-form-item {
      margin-top: 12px;
    }
  }
}

.table-box {
  height: 100vh;
  border-top: 1px solid #eee;
  overflow-x: auto;
  position: relative;
}
.export_btn{
  width: 64px;
  height: 24px;
  font-size: 13px;
  background-color: #3A405A;
}
</style>


